import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import SelectAsync from 'react-select/async';

export default class AccountsMapping extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            caller: props.Caller,
            data: null,
            loading: true,
            innerStatus: 0,
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        var p1 = this.httpPost("api/v1/accountmapping/get", {
            id: this.getCurrentFormId(),
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.state.data = data;
                }
            });
        Promise.all([p1]).then(r => {
            this.setState({
                loading: false
            })
        });
    }
    save(e) {
        if (!this.isNull(e)) e.preventDefault();

        if (this.state.data.record.type === 0) {
            this.showErorrMessage("لطفا یکی از کاربردها را انتخاب نمایید");
            return;
        }
        if (this.state.data.record.accountId === this.getDefaultGuid()) {
            this.showErorrMessage("لطفا حساب مرتبط را انتخاب نمایید");
            return;
        }

        this.httpPost("api/v1/accountmapping/save", {
            id: this.state.id,
            type: this.state.data.record.type,
            accountId: this.state.data.record.accountId,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.innerStatus = data.innerStatus;
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    setType(e) {
        this.state.data.record.type = e;
        if (e === 0) {
            this.state.data.record.accountId = this.getDefaultGuid();
            this.state.data.record.accountTitle = '';
        }
        this.setState({ data: this.state.data });
    }
    getAccountType() {
        if (this.state.data.record.type === 8 || this.state.data.record.type === 10)
            return 4;
        return 3;
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable">
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">
                                {this.state.data.record.id !== this.defaultGuid() ? "ویرایش اطلاعات حساب پیش فرض" : "افزودن حساب پیش فرض جدید"}
                            </h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-6">
                                        <div className="form-group">
                                            <label for="name" className="title1">کاربرد:</label>
                                            <select defaultValue={this.state.data.record.type} onChange={e => this.setType(parseInt(e.target.value))} autocomplete="off" className="form-control input-sm">
                                                <option value="0">انتخاب نمایید</option>
                                                <option value="1">حساب معین فروش سند فاکتور اتوماتیک</option>
                                                <option value="2">حساب معین خرید سند فاکتور اتوماتیک</option>
                                                <option value="3">حساب معین برگشت از فروش سند فاکتور اتوماتیک</option>
                                                <option value="4">حساب معین برگشت از خرید سند فاکتور اتوماتیک</option>
                                                <option value="5">حساب معین تخفیفات فروش سند فاکتور اتوماتیک</option>
                                                <option value="6">حساب معین تخفیفات خرید سند فاکتور اتوماتیک</option>
                                                <option value="7">حساب معین ارزش افزوده فروش سند فاکتور اتوماتیک</option>
                                                <option value="8">حساب تفصیل ارزش افزوده فروش سند فاکتور اتوماتیک</option>
                                                <option value="9">حساب معین ارزش افزوده خرید سند فاکتور اتوماتیک</option>
                                                <option value="10">حساب تفصیل ارزش افزوده خرید سند فاکتور اتوماتیک</option>
                                                <option value="11">حساب بهای تمام شده کالا</option>
                                                <option value="12">حساب موجودی کالا</option>
                                                <option value="13">حساب موجودی مواد اولیه</option>
                                                <option value="14">حساب معین اشخاص</option>
                                                <option value="15">حساب معین بانکها</option>
                                                <option value="16">حساب معین  صندوق</option>
                                                <option value="17">چکهای در جریان وصول</option>
                                                <option value="18">معین تنخواه گردان</option>
                                                <option value="19">معین هزینه ها</option>
                                                <option value="20">معین حسابهای دریافتنی</option>
                                                <option value="21">معین اعتبارات دریافتنی</option>
                                                <option value="22">معین سود تحقق نیافته فروش</option>
                                                <option value="23">معین صورتحسابهای هزینه ای ساختمان</option>
                                                <option value="24">معین صورتحسابهای درآمدی ساختمان</option>
                                                <option value="25">حساب معین درآمد بهره</option>
                                                <option value="26">حساب معین حسابهای انتظامی ما نزد دیگران</option>
                                                <option value="27">حساب معین حسابهای انتظامی دیگران نزد ما</option>
                                                <option value="28">حساب معین طرف حسابهای انتظامی</option>
                                                <option value="29">معین حسابهای پرداختنی</option>
                                                <option value="30">معین اسناد دریافتنی</option>
                                                <option value="31">معین اسناد پرداختنی</option>
                                                <option value="32">معین طرف حساب فاکتورهای فروش</option>
                                                <option value="33">معین طرف حساب فاکتورهای خرید</option>
                                                <option value="34">معین طرف حساب رسید انبار</option>
                                                <option value="35">حساب تفصیل اسناد دریافتنی</option>
                                                <option value="36">حساب تفصیل اسناد پرداختنی</option>

                                                <option value="37">حساب معین خرید خارجی سند فاکتور اتوماتیک</option>
                                                <option value="38">حساب معین برگشت از خرید خارجی سند فاکتور اتوماتیک</option>
                                                <option value="39">حساب معین تخفیفات خرید خارجی سند فاکتور اتوماتیک</option>
                                                <option value="40">حساب معین ارزش افزوده خرید خارجی سند فاکتور اتوماتیک</option>
                                                <option value="41">حساب تفصیل ارزش افزوده خرید خارجی سند فاکتور اتوماتیک</option>
                                                <option value="42">معین طرف حساب فاکتورهای خرید خارجی</option>

                                                <option value="43">حساب معین فروش خدمات سند فاکتور اتوماتیک</option>
                                                <option value="44">حساب معین خرید خدمات سند فاکتور اتوماتیک</option>
                                                <option value="45">حساب معین تخفیفات فروش خدمات سند فاکتور اتوماتیک</option>
                                                <option value="46">حساب معین تخفیفات خرید خدمات سند فاکتور اتوماتیک</option>
                                                <option value="47">حساب معین ارزش افزوده فروش خدمات سند فاکتور اتوماتیک</option>
                                                <option value="48">حساب تفصیل ارزش افزوده فروش خدمات سند فاکتور اتوماتیک</option>
                                                <option value="49">حساب معین ارزش افزوده خرید خدمات سند فاکتور اتوماتیک</option>
                                                <option value="50">حساب تفصیل ارزش افزوده خرید خدمات سند فاکتور اتوماتیک</option>
                                                <option value="51">معین طرف حساب فاکتورهای فروش خدمات</option>
                                                <option value="52">معین طرف حساب فاکتورهای خرید خدمات</option>
                                                <option value="53">معین کارمزد انتقال وجه</option>
                                                <option value="54">معین درآمد</option>
                                            </select>
                                        </div>
                                    </div>
                                    {this.state.data.record.type > 0 && <div className="col-sm-6">
                                        <div className="form-group">
                                            <label for="name" className="title1">حساب مرتبط:</label>
                                            <SelectAsync
                                                style={{ "width": "100%" }}
                                                defaultValue={this.state.data.record.accountId !== this.getDefaultGuid() ? [{ value: this.state.data.record.accountId, label: this.state.data.record.accountTitle }] : null}
                                                isMulti={false}
                                                placeholder="انتخاب معین طرف حساب"
                                                noOptionsMessage={({ inputValue }) =>
                                                    inputValue ? "نتیجه‌ای یافت نشد" : null
                                                }
                                                defaultOptions={[]}
                                                components={{
                                                    DropdownIndicator: () => null,
                                                    IndicatorSeparator: () => null,
                                                }}
                                                loadOptions={(inputValue, callback) => this.loadAccountOptions(inputValue, callback, this.getAccountType())}
                                                onChange={e => {
                                                    this.state.data.record.accountId = e.value;
                                                    this.state.data.record.accountTitle = e.label;
                                                }}
                                            />
                                        </div>
                                    </div>}
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}>انصراف</button>
                            <button type="submit" onClick={e => this.save(e)} className="btn btn-success">
                                ذخیره
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm()
            ];

        return contents;
    }
}